export default {"src":"/_next/static/media/arabian.a5407fa8.svg","height":573,"width":573,"blurWidth":0,"blurHeight":0};